<template>
    <div id="banking-details" class="banking-details-wrapper pt-8 scroll-mt-56">
        <HeadingBarComponent :step="6" />
        <div class="flex">
            <!-- Left Side -->
            <div class="basis-1/2 px-8">
                <div v-if="!bankingDetails.length">
                    <InputComponent type="password" label="Account Name" value="redacted" />
                    <InputComponent type="password" label="Account Number" value="redacted" />
                    <InputComponent type="password" label="Sort Code" value="redacted" />
                    <InputComponent type="password" label="IBAN" value="redacted" />
                    <InputComponent type="password" label="BIC/SWIFT" value="redacted" />
                    <HrComponent />
                </div>
                <div v-else v-for="(bankingDetail, index) in bankingDetails" :key="index">
                    <h3 class="mb-4">Account {{ index + 1 }}</h3>
                    <InputComponent label="Account Name" :value="bankingDetail.account_name" />
                    <InputComponent label="Account Number" :value="bankingDetail.account_number" />
                    <InputComponent label="Sort Code" :value="bankingDetail.sort_code" />
                    <InputComponent label="IBAN" :value="bankingDetail.iban" />
                    <InputComponent label="BIC/SWIFT" :value="bankingDetail.bic_swift" />
                    <HrComponent />
                </div>
                <ButtonComponent
                    @click="showHideBankingDetails"
                    :label="isLoading ? 'Loading...' : (!bankingDetails.length ? 'Show' : 'Hide') + ' banking details'"
                />
            </div>
        </div>
        <div class="px-8">
            <HrComponent />
        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import HeadingBarComponent from "@adminComponents/misc/HeadingBarComponent";
import HrComponent from "@adminComponents/misc/HrComponent";
import InputComponent from "@adminComponents/inputs/InputComponent";
import ButtonComponent from "@adminComponents/buttons/ButtonComponent";

export default {
    name: "BankingDetailsComponent",
    components: {
        HeadingBarComponent,
        HrComponent,
        InputComponent,
        ButtonComponent,
    },
    computed: {
        ...mapGetters(["submission"]),
    },
    data: function () {
        return {
            isLoading: false,
            bankingDetails: [],
        };
    },
    methods: {
        ...mapActions(["doGetSubmissionBankingDetails"]),
        showHideBankingDetails() {
            if (!this.bankingDetails.length) {
                // If the banking details are empty, let's get the data
                this.isLoading = true;
                this.doGetSubmissionBankingDetails(this.$route.params.user).then((response) => {
                    this.bankingDetails = response;
                    this.isLoading = false;
                });
            } else {
                // If we already have the data, then let's empty it to hide it
                this.bankingDetails = [];
            }
        },
    },
};
</script>
